module.exports = __webpack_public_path__ + "static/media/rescue_rangers.e7bd5c38.jpg";